import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)


import MasterPlanning from "../components/Planning/MasterPlanning.vue"
import PlanningIndex from "../components/Planning/Index.vue"
import PlanningDetails from "../components/Planning/PlanningDetails.vue"
import PlanningDetailsActions from "../components/Planning/PlanningDetailsActions.vue"
import PlanningSectionHeader from "../components/Planning/PlanningSectionHeader.vue"
import PlanningSectionActions from "../components/Planning/PlanningSectionActions.vue"
import PlanningSourcePanel from "../components/Planning/PlanningSourcePanel.vue"
import PlanningHeader from "../components/Planning/PlanningHeader.vue"
import PlanningActions from "../components/Planning/PlanningActions.vue"
import PlanningMenu from "../components/Planning/PlanningMenu.vue"
import PlanningLogList from "../components/Planning/PlanningLogList.vue"
import PlanningPodcastList from "../components/Planning/PlanningPodcastList.vue"
import PlanningStats from "../components/Planning/PlanningStats.vue"
//import MusicSectionMenu from "../components/Boxes/MusicSectionMenu.vue";
//import TrackList from "@/components/Library/TrackList";
//=============================================================================================================
import App from '@/App';
import Home from '@/views/Home';
import Dashboard from '@/views/Dashboard';
//=============================================================================================================
import Error404 from "@/components/common/Error404";
import trackSection from './sections/tracks';
import librarySection from './sections/library';
import boxSection from './sections/boxes';
import clockSection from './sections/clocks';
import dtSection from './sections/dayTemplates';
import wkSection from './sections/weekTemplates';
import { authGuard } from '@/auth/guard';
import MasterSimpleSection from "@/components/Report/__MasterSimpleSection";
import MasterReportListSection from "@/components/Report/__MasterReportListSection";
import MasterMultiSearchListSection from "@/components/Report/__MasterMultiSearchListSection";
import MasterMultiSearchSimpleSection from "@/components/Report/__MasterMultiSearchSimpleSection";


//=============================================================================================================
const routes = [
    { path: '/', component: App ,  beforeEnter: authGuard },
    {
        name: "Dashboard", path: '/:stationUid', component: Dashboard,  beforeEnter: authGuard
    },
    {
        name: "reportUPDetail",  path: '/:stationUid/report-upload/:sequenceidentifier', components :{ default: MasterSimpleSection, },
    },
    {
        name: "reportUpload" , path: '/:stationUid/report-list-upload/:since', components :{ default: MasterReportListSection, },
    },
    {
        name: "multiSearchDetail",  path: '/:stationUid/multi-search-detail/:id', components :{ default: MasterMultiSearchSimpleSection, },
    },
    {
        name: "multiSearchDetailMissing",  path: '/:stationUid/multi-search-detail/:id', components :{ default: MasterMultiSearchSimpleSection, },
    },

    {
        name: "multiSearchList" , path: '/:stationUid/list-multi-search/:since', components :{ default: MasterMultiSearchListSection, },
    },
    trackSection,
    // //*******************************************************************
    librarySection,
    boxSection,
    clockSection,
    dtSection,
    wkSection,
    {
         path: '/:stationUid/planning',
         beforeEnter: authGuard,
         components: {
             default: MasterPlanning,
         },
         children: [
             {
                 name: "PlanningHome",
                 path: "",
                 components: {
                     default: PlanningIndex,
                     subPageHeader: PlanningSectionHeader,
                     pageActions: PlanningSectionActions,
                     rightPanel: PlanningSourcePanel,
                     pageSubMenu: null
                 }
             },
             {
                 name: "PlanningDetails",
                 path: ':planningDate/details',
                 components: {
                     default: PlanningDetails,
                     subPageHeader: PlanningHeader,
                     rightPanel: null,
                     pageActions: PlanningDetailsActions,
                     pageSubMenu: PlanningMenu,
                 },
             },
             {
                 name: "PlanningPodcasts",
                 path: ':planningDate/podcasts',
                 components: {
                     default: PlanningPodcastList,
                     subPageHeader: PlanningHeader,
                     rightPanel: null,
                     pageActions: null,
                     pageSubMenu: PlanningMenu,
                 },
             },
             {
                 name: "PlanningLogs",
                 path: ':planningDate/logs',
                 components: {
                     default: PlanningLogList,
                     subPageHeader: PlanningHeader,
                     rightPanel: null,
                     pageActions: null,
                     pageSubMenu: PlanningMenu,
                 },
             },
             {
                 name: "PlanningStats",
                 path: ':planningDate/stats',
                 components: {
                     default: PlanningStats,
                     subPageHeader: PlanningHeader,
                     rightPanel: null,
                     pageActions: null,
                     pageSubMenu: PlanningMenu,
                 },
             },
         ]
    },
    { path: '*', redirect: 'Error404' }
];
//=============================================================================================================
const Router = new VueRouter({
    mode: 'history',
    routes: routes
});
//=============================================================================================================
export default Router;
